import { FilterPreset, FilterPresetEvent } from "../../interfaces/filters";

export function filterPresetsReducer(
  filters: FilterPreset[],
  event: FilterPresetEvent,
) {
  switch (event.event) {
    case "add":
      return [...filters, event.filters];
    case "set":
      return event.filters;
    case "delete":
      return filters.filter((f) => !event.ids.includes(f.id));
    default:
      return filters;
  }
}
